/**
 * Creates a debounced function that delays invoking `func` until after `wait` milliseconds
 * have elapsed since the last invocation.
 *
 * When `leading` is true, the function fires immediately on the first call (leading edge),
 * and also fires on the trailing edge if there were subsequent calls during the wait period
 * (matching lodash behavior with leading:true, trailing:true).
 */
export function debounce(func, wait) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    leading = false
  } = options;
  let timeoutId;
  // Track args for the trailing call; null means no subsequent calls after leading
  let pendingArgs = null;
  let pendingContext;
  function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (leading && timeoutId === undefined) {
      // Fire immediately on the leading edge, no pending trailing needed yet
      func.apply(this, args);
      pendingArgs = null;
    } else {
      // Record these args for the trailing call
      pendingArgs = args;
      pendingContext = this;
    }
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      timeoutId = undefined;
      if (pendingArgs !== null) {
        func.apply(pendingContext, pendingArgs);
        pendingArgs = null;
        pendingContext = undefined;
      }
    }, wait);
  }
  debounced.cancel = function cancel() {
    clearTimeout(timeoutId);
    timeoutId = undefined;
    pendingArgs = null;
    pendingContext = undefined;
  };
  return debounced;
}